import { useMemo } from "react";
import { getContainerStyleClasses } from "../utils/containerStyleUtils";

/**
 * Custom hook to manage container styling properties (rounded borders, etc.)
 * @param {Object} component - Component object containing container_style data
 * @returns {string} - Container style classes
 */
const useContainerStyle = (component = null) => {
  const styleClasses = useMemo(() => {
    if (!component || !component.container_style) return "";
    return getContainerStyleClasses(component.container_style);
  }, [component]);

  return styleClasses;
};

export default useContainerStyle;
